const React = require('react');
const { Pill } = require('@andes/badge');
const { getEventTracker } = require('../../../../../utils/event-tracker');

const ComponentText = ({ pillText, title, bullets, link, track }) => {
  const Tracker = getEventTracker();

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_online', {
      product_name: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  function setTrack(event) {
    Tracker.send('mpdevelopers/documentation/click_online', event);
    sendToMelidata(event);
  }

  return (
    <div className="component-text-container">
      <Pill
        className="component-text-pill"
        color="gray"
        size="small"
        hierarchy="quiet"
        roundedCorners={['top-right', 'top-left', 'bottom-right', 'bottom-left']}
      >
        {pillText}
      </Pill>
      <a href={link} target="_self" rel="noreferrer" className="component-text-link" onClick={() => { setTrack(track); }}>
        <h5 className="component-text-title">{title}</h5>
      </a>
      {bullets?.map((bullet) => (
        <li className="online-text-bullet">
          {bullet}
        </li>
      ))}
    </div>
  );
};

module.exports = ComponentText;
